import CenteredErrorMessage from './CenteredErrorMessage';
export default CenteredErrorMessage;



// WEBPACK FOOTER //
// ./src/components/CenteredErrorMessage/index.js